import {
  REQUEST_GET_PRIVACY_POLICY,
  SUCCESS_GET_PRIVACY_POLICY,
  FAILURE_GET_PRIVACY_POLICY,
} from '../constants/types';

const initialState = {
  errorMessage: '',
  requested: false,
  loading: false,
  data: [],
};

const PrivacyPolicyReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_GET_PRIVACY_POLICY:
      return { ...state, loading: true };

    case SUCCESS_GET_PRIVACY_POLICY:
      return { ...state, requested: true, loading: false, data: action.payload.data };

    case FAILURE_GET_PRIVACY_POLICY:
      return { ...state, loading: false, errorMessage: action.payload.err };

    default:
      return { ...state };
  }
};

export default PrivacyPolicyReducer;
